/** Platform fee withheld from creator Whop cash payouts (5% of cash only). */
export const CREATOR_PAYOUT_PLATFORM_FEE_RATE = 0.05;

export function roundUsd(amount: number): number {
  return Math.round(amount * 100) / 100;
}

/** 5% fee on cash payout amounts (not product value). */
export function calculateCreatorPayoutPlatformFeeUsd(cashUsd: number): number {
  if (cashUsd <= 0) return 0;
  return roundUsd(cashUsd * CREATOR_PAYOUT_PLATFORM_FEE_RATE);
}

/** Net cash after platform fee. */
export function calculateCreatorNetPayoutUsd(cashUsd: number): number {
  if (cashUsd <= 0) return 0;
  return roundUsd(cashUsd - calculateCreatorPayoutPlatformFeeUsd(cashUsd));
}

/**
 * Collab withdrawable total: fee on `cashUsd` only; `productValueUsd` passes through in full.
 */
export function calculateCollabNetPayoutUsd(cashUsd: number, productValueUsd = 0): number {
  const productUsd = productValueUsd > 0 ? roundUsd(productValueUsd) : 0;
  return roundUsd(calculateCreatorNetPayoutUsd(cashUsd) + productUsd);
}
